import {
  type AttributionTouchKindType,
  CLICK_ID_KEYS,
  type IAttribution,
  UTM_PARAM_KEYS,
} from '@repo/analytics';
import { classifyChannel } from '@repo/config';
import { pageContextFromPathname } from '../page-context-from-pathname';

export function parseCurrentAttribution(touchKind: AttributionTouchKindType): IAttribution | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  const get = (key: string): string | null => params.get(key);
  const hasAny =
    UTM_PARAM_KEYS.some((k) => get(k) !== null) ||
    CLICK_ID_KEYS.some((k) => get(k) !== null) ||
    get('ref') !== null;
  if (!hasAny) {
    return null;
  }
  const referrerHost = (() => {
    try {
      return document.referrer ? new URL(document.referrer).host.slice(0, 200) : null;
    } catch {
      return null;
    }
  })();
  const pageContext = pageContextFromPathname(window.location.pathname);
  const channel = classifyChannel({
    source: get('utm_source'),
    medium: get('utm_medium'),
    referrerUserId: get('ref'),
    referrerHost,
    gclid: get('gclid'),
  });
  return {
    source: get('utm_source'),
    medium: get('utm_medium'),
    campaign: get('utm_campaign'),
    term: get('utm_term'),
    content: get('utm_content'),
    referrer: referrerHost,
    gclid: get('gclid'),
    fbclid: get('fbclid'),
    ttclid: get('ttclid'),
    msclkid: get('msclkid'),
    rawUrl: window.location.href.slice(0, 500),
    referrerUserId: get('ref'),
    landingTemplate: pageContext.template,
    landingPhrase: pageContext.phrase,
    channel,
    socialRef: get('cm_sref'),
    touchKind,
    capturedAt: Date.now(),
  };
}
